import RootLayout from '@/component/wing/Layout';
import Img from '@/component/Img';
import useInitImg from '@/hooks/useInitImg';
import styles from './style.module.scss';


const FeaturePage = () => {
  return (
    <RootLayout className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.logo} />
        <div className={styles.title}>Your Safety Matters</div>
        <div className={styles.description}>At Wing, we do everything we can to keep a safe and fun environment. Our community's safety is our top priority.
          Our moderation team works around the clock to prevent fake profiles, making Wing safe to use.
        </div>
      </div>
    </RootLayout>
  );
};

export default FeaturePage;

